/*
 * LocaleToggle Messages
 *
 * This contains all the text for the Footer component.
 */
import { defineMessages } from 'react-intl';

export const scope = 'app.components.NavBar';

export default defineMessages({
  home: {
    id: `${scope}.home`,
    defaultMessage: 'Home'
  },
  borrow: {
    id: `${scope}.borrow`,
    defaultMessage: 'Borrow'
  },
  lend: {
    id: `${scope}.lend`,
    defaultMessage: 'Lend'
  },
  aboutUs: {
    id: `${scope}.aboutUs`,
    defaultMessage: 'About Us'
  },
  faq: {
    id: `${scope}.faq`,
    defaultMessage: 'F.A.Q'
  },
  logIn: {
    id: `${scope}.logIn`,
    defaultMessage: 'Login'
  },
  wantToBorrow: {
    id: `${scope}.wantToBorrow`,
    defaultMessage: 'Want to Borrow'
  },
  wantToLend: {
    id: `${scope}.wantToLend`,
    defaultMessage: 'Want to Lend'
  },
  modalParagraph: {
    id: `${scope}.modalParagraph`,
    defaultMessage:
      'modalParagraph'
  },
  modalLine1: {
    id: `${scope}.modalLine1`,
    defaultMessage:
      'modalLine1'
  },
  modalLine2: {
    id: `${scope}.modalLine2`,
    defaultMessage: 'modalLine2'
  },
  modalLine3: {
    id: `${scope}.modalLine3`,
    defaultMessage:
      'modalLine3'
  },
  modalFormula1: {
    id: `${scope}.modalFormula1`,
    defaultMessage:
        'modalFormula1'
  },
  modalFormula2: {
    id: `${scope}.modalFormula2`,
    defaultMessage:
        'modalFormula2'
  }
});



// WEBPACK FOOTER //
// ./src/components/NavBar/messages.js